exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n\n.header__CardFinanceSales-module___HtqRE {\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.iconEditSquare__CardFinanceSales-module___kRUKi:hover {\n  color: #0acf97;\n}\n\n@media (max-width: 375px) {\n  .card__CardFinanceSales-module___1ip4p {\n    min-width: 260px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"header": "header__CardFinanceSales-module___HtqRE",
	"iconEditSquare": "iconEditSquare__CardFinanceSales-module___kRUKi",
	"card": "card__CardFinanceSales-module___1ip4p"
};